/** 공고 작성 플로우용 sessionStorage 키 일괄 제거 (작성 완료 시) */
export function clearJobPostSessionStorage() {
	;[
		'JobPostSelectedTours',
		'ThirdPageData',
		'JobPostContractType',
		'JobPostPeriodType',
		'JobPostCurrentYear',
	].forEach((k) => sessionStorage.removeItem(k))
}

/** 공고 작성 1단계 진입 시: 대회 선택·3단계 임시만 초기화 (유형/연도는 유지) */
export function clearJobPostTourDraftSession() {
	sessionStorage.removeItem('JobPostSelectedTours')
	sessionStorage.removeItem('ThirdPageData')
}
